/*
 * @Descripttion: 产品快速跳转
 * @Author: huangfuchunmei
 * @Date: 2023-08-29 15:56:48
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-13 17:03:14
 */
import React from 'react'
import { IBanner } from "@/common/types";
import styles from './index.module.scss'
import LazyMedia from '@/components/LazyMedia';

interface IProps {
  productsIntroList?: IBanner[]; // 首页banner4数据
  ctry?: string;
  words: Record<string, string>;
  device: string
}
const ProductsIntroduction:React.FC<IProps> = ({words, device, ctry, productsIntroList}) => {
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
    <>
      {productsIntroList && productsIntroList.length > 0 && (
        <div className={styles['content-intro-wrap']}>
          <div className={styles['intro-wrap']}>
            {productsIntroList.map((item:IBanner) => (
              <div className={styles['intro-item']} key={item.id}>
                <LazyMedia type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                <div className={styles['intro-content-wrap']}>
                  {item?.isShowTitle === 1 && (
                    <h2>{item?.name}</h2>
                  )}
                  <h4 className="preLine">{item?.remark}</h4>
                  <p className={styles['btn-group']}>
                    {item?.url && (
                      <a href={item.url}>
                        <span className={styles['learn-more']}>{words?.common_learn_more}</span>
                      </a>
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
          {/* <div className={styles['banner-wrap']}>
            <LazyMedia type="image" src={device==='mobile' ? banners3.imagePhone : banners3.imagePc} alt="" />
            <div className={styles['intro-content-wrap']}>
              <h2>{banners3.title}</h2>
              <h4>{banners3.describe}</h4>
              <p className={styles['btn-group']}>
                <Link to={`/${ctry}${banners3.link}`}>
                  <span className={styles['learn-more']}>{words?.common_learn_more}</span>
                </Link>
              </p>
            </div>
          </div> */}
        </div>
      )}
    </>

  )
}
export default ProductsIntroduction
